// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602191552/js/" + chunkId + "." + {"44":"d5e100ca","225":"fd26e1dd","481":"8820c002","486":"74d995ba","770":"84563ded"}[chunkId] + ".0.3617678923161758.chunk.js";
};